// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import { IRostelecomStyleParamsStoreState } from './rostelecom-styles-store';
import _ from 'lodash';

const sizeProps = {};
const widthProps = {};
const heightProps = {};
const fontProps = {};
const unitlessProps = { fontSize: true, lineHeight: true };
_.forEach(['margin', 'padding', 'lineHeight'], key => {
    sizeProps[key] = true;
});
_.forEach(
    [
        'height',
        'minHeight',
        'maxHeight',
        'marginTop',
        'marginBottom',
        'paddingTop',
        'paddingBottom',
        'top',
        'bottom',
        'lineHeight'
    ],
    key => {
        sizeProps[key] = true;
        heightProps[key] = true;
    }
);
_.forEach(
    [
        'width',
        'minWidth',
        'maxWidth',
        'marginLeft',
        'marginRight',
        'paddingLeft',
        'paddingRight',
        'left',
        'right'
    ],
    key => {
        sizeProps[key] = true;
        widthProps[key] = true;
    }
);
_.forEach(['fontSize'], key => {
    sizeProps[key] = true;
    fontProps[key] = true;
});

// tslint:disable-next-line:typedef (autogenerated)
function convertToPx(value: string, em: number, warnCallback?: (string) => void): number | string {
    let val: any = value;
    const ptIndex = value.indexOf('pt');
    const emIndex = value.indexOf('em');
    const pxIndex = value.indexOf('px');
    if (ptIndex > 0) {
        val = (parseFloat(value.substring(0, ptIndex)) * 4) / 3;
        if (warnCallback) {
            warnCallback('converting from pt to px');
        }
    } else if (emIndex > 0) {
        val = parseFloat(value.substring(0, emIndex)) * em;
        if (warnCallback) {
            warnCallback('converting from em to px');
        }
    } else if (pxIndex > 0) {
        val = parseFloat(value.substring(0, pxIndex));
    } else if (value.indexOf('%') <= 0 && value !== 'auto' && value !== 'inherit') {
        val = parseFloat(value);
        if (isNaN(val)) {
            val = value;
            if (warnCallback) {
                warnCallback('unrecognized string value ' + value);
            }
        }
    }
    return val;
}

function multW(styleParams: IRostelecomStyleParamsStoreState, val: number): number {
    return Math.round(val * styleParams.widthScale * 10000) / 10000;
}

function multH(styleParams: IRostelecomStyleParamsStoreState, val: number): number {
    return Math.round(val * styleParams.heightScale * 10000) / 10000;
}

function multF(styleParams: IRostelecomStyleParamsStoreState, val: number): number {
    return Math.round(val * styleParams.fontScale * 10000) / 10000;
}

function scaleValue(
    styleParams: IRostelecomStyleParamsStoreState,
    key: string,
    value: number
): number {
    let val = value;
    if (widthProps[key]) {
        val = multW(styleParams, val);
    } else if (heightProps[key]) {
        val = multH(styleParams, val);
    } else if (fontProps[key]) {
        val = multF(styleParams, val);
    }
    return val;
}

function processValue(
    styleParams: IRostelecomStyleParamsStoreState,
    em: number,
    key: string,
    value: string | number,
    // tslint:disable-next-line:typedef (autogenerated)
    warnCallback: (string) => void
): number | string {
    let val = value;
    if (typeof value === 'string') {
        let array: any[] = _.filter(value.split(' '), v => !!v && v !== ' ');
        array = _.map(array, v => {
            return convertToPx(v, em, warnCallback);
        });
        if (array.length > 1) {
            // covert to implicit props;
            if (typeof array[0] === 'number') {
                array[0] = multH(styleParams, array[0]) + 'px';
            }
            if (typeof array[1] === 'number') {
                array[1] = multW(styleParams, array[1]) + 'px';
            }
            if (typeof array[2] === 'number') {
                array[2] = multH(styleParams, array[2]) + 'px';
            }
            if (typeof array[3] === 'number') {
                array[3] = multW(styleParams, array[3]) + 'px';
            }
            val = array.map(v => v.toString()).join(' ');
        } else {
            if (typeof array[0] === 'number') {
                val = scaleValue(styleParams, key, array[0]);
                if (unitlessProps[key]) {
                    val = val + 'px';
                }
            } else {
                val = array[0];
            }
        }
    } else if (typeof val === 'number') {
        val = scaleValue(styleParams, key, val);
    }
    return val;
}

const defaultEm = 14.6667;

// tslint:disable-next-line:typedef (autogenerated)
function getEms(plainStylesObject): { normal: number; font: number } {
    // tslint:disable-next-line:no-string-literal (autogenerated)
    const fontSize = plainStylesObject['fontSize'];
    if (typeof fontSize === 'string' && fontSize.indexOf('em') >= 0) {
        return {
            normal: convertToPx(fontSize, defaultEm) as number,
            font: defaultEm
        };
    }
    return {
        normal: defaultEm,
        font: defaultEm
    };
}

let incorrectStyles = [];
let incorrectComponents = [];
const dlayedPrintWarn = _.debounce(() => {
    console.warn('Please rewrite styles for components', incorrectComponents, incorrectStyles);
    incorrectStyles = [];
    incorrectComponents = [];
}, 1000);

// tslint:disable-next-line:typedef (autogenerated)
function warn(component, stylesObject, messages) {
    if (_.indexOf(incorrectComponents, component) < 0) {
        incorrectComponents.push(component);
    }
    incorrectStyles.push({ component, styles: stylesObject, errors: messages });
    dlayedPrintWarn();
}

export function processStyles(
    styleParams: IRostelecomStyleParamsStoreState,
    stylesObject: any,
    // tslint:disable-next-line:typedef (autogenerated)
    component,
    // tslint:disable-next-line:typedef (autogenerated)
    warnCallback?: (string) => void
): any {
    try {
        const res = {};
        const messages = [];
        if (!warnCallback) {
            // tslint:disable-next-line:no-parameter-reassignment (autogenerated)
            warnCallback = message => {
                messages.push(message);
            };
        }
        if (Array.isArray(stylesObject)) {
            return _.map(stylesObject, v => processStyles(styleParams, v, component, warnCallback));
        }
        if (typeof stylesObject === 'object') {
            const ems = getEms(stylesObject);
            _.forOwn(stylesObject, (value: any, key: string) => {
                if (key.indexOf('Fix') >= 0) {
                    res[key.substring(0, key.length - 3)] = value;
                    return;
                }
                if ((typeof value === 'string' || typeof value === 'number') && sizeProps[key]) {
                    res[key] = processValue(
                        styleParams,
                        fontProps[key] ? ems.font : ems.normal,
                        key,
                        value,
                        warnCallback
                    );
                } else if (Array.isArray(value)) {
                    res[key] = _.map(value, v =>
                        processStyles(styleParams, v, component, warnCallback)
                    );
                    // tslint:disable-next-line:prefer-conditional-expression (autogenerated)
                } else if (typeof value === 'object') {
                    res[key] = processStyles(styleParams, value, component, warnCallback);
                } else {
                    res[key] = value;
                }
            });
        }
        if (messages.length > 0) {
            warn(component, stylesObject, messages);
        }
        return res;
    } catch (error) {
        console.error(error);
        return stylesObject;
    }
}
